import { ReactElement, useCallback } from 'react';
import { OptionProps, GroupBase } from 'react-select';
import { Obj } from '@/types/common';

export function Option<T extends Obj>(
  props: OptionProps<T, false | true, GroupBase<T>>,
  optionValue?: keyof T,
  customOption?: (data: T) => ReactElement | null
): ReactElement | null {
  const { innerProps, getValue, data, children } = props;
  const { onMouseMove, onMouseOver, ...newInnerProps } = innerProps;
  const [value] = getValue();

  const getOption = useCallback(() => {
    if (customOption) {
      return customOption(data);
    } else return <p>{children}</p>;
  }, []);

  return (
    <div
      className={`block box-border px-[12px] py-[8px] select-none w-full option-text ${
        value && value[optionValue || 'value'] === data[optionValue || 'value'] && '!bg-[#eef0f6]'
      } hover:bg-bg-color`}
      {...newInnerProps}
    >
      {getOption()}
      {/* <p>{children}</p> */}
    </div>
  );
}
